/*!
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

<template>
  <div class="devices">
    <h1 class="ui header">
      <i aria-hidden="true" class="microchip icon">
      </i>
      My devices
    </h1>
    <div v-if="failed" class="ui error message">
      <div class="content">
        <div class="header">Failed to fetch devices. Please try the following:</div>
        <ul class="list">
          <li class="content">Refresh the page or try again later.</li>
          <li class="content">If problems persist please reach out to IT.</li>
        </ul>
      </div>
    </div>

    <div v-if="loadingPage" class="ui active black inline centered loader"></div>
    <div v-if="devices.length">
      <p>Hello {{ claims.name }}, these are the assets you currently have checked out.</p>
      <table class="ui table">
        <thead>
          <tr>
            <th>Img</th>
            <th>Model</th>
            <th>Serial</th>
            <th>Checkout Date</th>
            <th>Reassign</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(device, index) in devices" :key="device.serial" :id="'device-' + index">
            <td v-if="device.image"><img class="ui centered mini image" :src="device.image"></td>
            <td v-if="!device.image"><i class="image big icon"></i></td>
            <td>{{ device.model.name }}</td>
            <td><a href="#" @click="showDevice(device)">{{ device.serial }}</a></td>
            <td>{{ device.last_checkout.datetime }}</td>
            <td><button class="ui primary button" :class="{ loading: (loadingIdx == index) }"
                @click="reassignAsset(device, index)">Reassign</button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <ReassignAssetModal @success="success" ref="reassignAssetModal" />
  <Device ref="deviceModal" />
</template>

<script>
import axios from 'axios'
import sampleConfig from '../config'
import ReassignAssetModal from './ReassignAssetModal.vue';
import Device from './Device.vue';

export default {
  name: 'Devices',
  components: {
    ReassignAssetModal,
    Device
  },
  data() {
    return {
      failed: false,
      loadingIdx: null,
      loadingPage: true,
      devices: [],
      claims: ''
    }
  },
  computed: {
    welcomeMessage() {
      console.log(`these are the claims ${this.claims}`)
      return this.claims.name
    }
  },
  methods: {
    async getUserDevices() {
      // Get user's devices
      const response = await axios.get(
        sampleConfig.resourceServer.devicesUrl,
        {
          headers: {
            Authorization: `Bearer ${this.$auth.getAccessToken()}`
          }
        }
      )
      const devices = response.data.rows.map((device) => {
        const customFields = "custom_fields";
        const commonFields = ["id", "serial", "last_checkout", "model", "image"];

        // Extract custom attributes
        let asset = {};
        for (const prop in device[customFields]) {
          asset[prop] = device[customFields][prop]['value'];
        }

        for (const field of commonFields) {
          asset[field] = device[field];
        }
        return asset;
      });

      return devices;
    },
    genDisplayAsset(device) {
      // transform device info before display
      let displayAsset = {...device};
      displayAsset.last_checkout = device.last_checkout.datetime;
      displayAsset.model = device.model.name;
      delete displayAsset.image;
      delete displayAsset.id;
      return displayAsset;
    },
    showDevice(device) {
      let asset = this.genDisplayAsset(device)
      this.$refs.deviceModal.showModal(asset);
    },
    success(serial) {
      let index = this.devices.findIndex(device => device.serial === serial);
      this.devices.splice(index, 1);
    },
    async reassignAsset(device, index) {
      this.loadingIdx = index;
      const response = await axios.get(
        sampleConfig.resourceServer.usersUrl,
        {
          headers: { Authorization: `Bearer ${this.$auth.getAccessToken()}` }
        }
      )
      const users = response.data.rows.map((user) => {
        return {
          id: user.id,
          name: user.name,
          email: user.email
        }
      }
      )
      this.$refs.reassignAssetModal.showModal(device, users);
      this.loadingIdx = null;
    }
  },
  async created() {
    try {
      this.loadingPage = true;
      this.claims = await this.$auth.getUser();
      this.devices = await this.getUserDevices();
      this.loadingPage = false;
    } catch (e) {
      console.error(e)
      this.failed = true
    }
  },
}
</script>
